import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { StaffsHelpbuttonService } from 'src/app/services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';

@Component({
  selector: 'app-helpbutton-staff-photo-editor-card',
  templateUrl: './helpbutton-staff-photo-editor-card.component.html',
  styleUrls: ['./helpbutton-staff-photo-editor-card.component.scss']
})
export class HelpbuttonStaffPhotoEditorCardComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() staffInfo;
  showSpinner: boolean;

  constructor(private snackbarService: SnackBarService,
    private staffService: StaffsHelpbuttonService,
    private validationImageService: ValidationImageService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: base64, width: 250, height: 250 }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.staffInfo.UserImage = result;
            this.showSpinner = true;
            this.spinnerService.show('staff-photo-editor-spinner');
            this.staffService.updateImageStaff(this.staffInfo.InternalId, result).subscribe(
              (res) => {
                this.staffService.refreshStaff();
                this.showSpinner = false;
                this.spinnerService.hide('staff-photo-editor-spinner');
              },
              (error) => {
                this.staffService.refreshStaff();
                this.showSpinner = false;
                this.spinnerService.hide('staff-photo-editor-spinner');
                this.snackbarService.open(error['error']['message'], 'error');
              }
            );
          }
        });
      },
      (error) => {
        this.staffService.refreshStaff();
        this.snackbarService.open(error, 'error');
      }
    );
  }
}
